import axios from 'axios';
import { toastr } from "react-redux-toastr";
import * as types from "../constants";

import setAuthToken from '../../utils/setAuthToken';

// Load User
export const loadUser = () => async dispatch => {
  if (localStorage.token) {
    setAuthToken(localStorage.token);
  }

  try {
    const res = await axios.get('/api/auth/');

    dispatch({
      type: types.USER_LOADED,
      payload: res.data
    });
  } catch (err) {
    dispatch({
      type: types.AUTH_ERROR
    });
  }
};

// Register User
export const register = ({ name, email, password, phone }) => async dispatch => {
  const config = {
    headers: {
      'Content-Type': 'application/json'
    }
  };

  const body = JSON.stringify({ name, email, password, phone });

  try {
    const res = await axios.post('/api/auth/register', body, config);

    dispatch({
      type: types.REGISTER_SUCCESS,
      payload: res.data
    });

    dispatch(loadUser());
  } catch (err) {
    console.log(err.response)
    const errors = err.response.data.error;

    if (errors) {
      errors.forEach(error => toastr.error('Error ',error.msg));
    }

    dispatch({
      type: types.REGISTER_FAIL
    });
  }
};

//Passwords don't match

export const passDoNot = () => async dispatch => {
  toastr.error('Passwords do not match!')
}

// Login User
export const login = (email, password) => async dispatch => {
  const config = {
    headers: {
      'Content-Type': 'application/json'
    }
  };

  const body = JSON.stringify({ email, password });

  try {
    const res = await axios.post('/api/auth/login', body, config);
    console.log(res.data);
    dispatch({
      type: types.LOGIN_SUCCESS,
      payload: res.data
    });

    dispatch(loadUser());
  } catch (err) {
    console.error(err);
    console.log(err.response)
    const errors = err.response.data.errors;

    if (errors) {
      errors.forEach(error => toastr.error('Error ',error.msg));
    }

    dispatch({
      type: types.LOGIN_FAIL
    });
  }
};

// Logout / Clear Profile
export const logout = () => dispatch => {
  dispatch({ type: types.CLEAR_PROFILE });
  dispatch({ type: types.LOGOUT });
};
